import React, { useRef, useEffect } from 'react';

const TrustBox = () => {
  const trustBoxRef = useRef(null);

  useEffect(() => {
    // Once the component mounts, load the widget if the Trustpilot object is available.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustBoxRef.current, true);
    }
  }, []);

  return (
    <div
      ref={trustBoxRef}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="66d1b85bf3f7fe4eab393f97"
      data-style-height="52px"
      data-style-width="100%"
    >
      <a
        href="https://uk.trustpilot.com/review/www.carinformation.co.uk"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustBox;
